import { Routes, Route, Navigate } from "react-router-dom";


import Visatronix from "./Visatronix";

const visatronixRoutes = [
     {routeName: 'family-reunion' , component: <Visatronix/>},
     {routeName: 'legalization' , component: <Visatronix/>},
     {routeName: 'nationality-visa' , component: <Visatronix/>},
     {routeName: 'study-visa' , component: <Visatronix/>},
     

];

const VisatronixRoutes = () => {
    return (
    <Routes>
       {visatronixRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default VisatronixRoutes;